/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const o=1,t=[0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1],c=[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],e=256;export{t as alphaToRgbaChannelSelectorMatrix,c as rgbaToRgbaChannelSelectorMatrix,e as shadeTextureSize,o as sigma};
